import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Deep merge: defaults ← overrides. Only plain objects are merged; arrays/primitives are replaced. */
export function deepMerge<T extends Record<string, unknown>>(defaults: T, ...sources: Array<Record<string, unknown> | null | undefined>): T {
  const result = { ...defaults } as Record<string, unknown>;
  for (const source of sources) {
    if (!source) continue;
    for (const key of Object.keys(source)) {
      const srcVal = source[key];
      const defVal = result[key];
      if (srcVal && typeof srcVal === 'object' && !Array.isArray(srcVal) && defVal && typeof defVal === 'object' && !Array.isArray(defVal)) {
        result[key] = deepMerge(defVal as Record<string, unknown>, srcVal as Record<string, unknown>);
      } else if (srcVal !== undefined) {
        result[key] = srcVal;
      }
    }
  }
  return result as T;
}

// ── Dev-only logger (tree-shaken in production builds) ──────────────────────
const isDev = import.meta.env.DEV;

export const devLog = {
  log: (...args: unknown[]) => { if (isDev) console.log(...args); },
  warn: (...args: unknown[]) => { if (isDev) console.warn(...args); },
  error: (...args: unknown[]) => { if (isDev) console.error(...args); },
};

/** Formatea bytes a B, KB o MB */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
